// extracted by mini-css-extract-plugin
export var picture_one = "background-module--picture_one--F9fPb";
export var pic1 = "background-module--pic1--Avmmo";
export var picture_two = "background-module--picture_two--YrF2Z";
export var pic2 = "background-module--pic2--liDMo";